import { useSendDialogMessageDialogSendPostMutation } from '@shared/api';

export const useSendMessage = () => {
  const [sendDialogMessageMutation, { isLoading }] = useSendDialogMessageDialogSendPostMutation();

  const sendDialogMessage = async (clientId: number, message: string) => {
    try {
      await sendDialogMessageMutation({
        bodySendDialogMessageDialogSendPost: {
          message,
          client_id: clientId,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  return {
    sendDialogMessage,
    isLoading,
  };
};
